import React, { useState } from 'react';
import { Typography, Link,  Snackbar, Box, Alert, } from '@mui/material';
import { AuthContainer, AuthCard, AuthTextField, AuthButton } from './styles/AuthStyles';

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  const handleLogin = (ev) => {
    if (!email || !password) {
      setSnackbar({
        open: true,
        message: "両方のフィールドに入力が必要です。",
        severity: 'error',
      });
      return;
    }
    // ログイン処理
    onLogin(email, password, (err) => {
      const res = err.response;
      setSnackbar({
        open: true,
        message: res.data?.message,
        severity: 'error',
      });
    });
  };

  return (
    <AuthContainer>
      <AuthCard>
        <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ fontWeight: 'bold' }}>
          FocusTrack
        </Typography>
        <Typography variant="h5" gutterBottom align="center">
          ログイン
        </Typography>
        <Box>
          <AuthTextField
            fullWidth
            label="メールアドレス"
            variant="outlined"
            type="email"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            required
          />
          <AuthTextField
            fullWidth
            label="パスワード"
            variant="outlined"
            type="password"
            onChange={(e) => setPassword(e.target.value)}
            value={password}
            required
          />
          <AuthButton fullWidth onClick={handleLogin} variant="contained" type="submit">
            ログイン
          </AuthButton>
        </Box>
        <Typography align="center" sx={{ mt: 2 }}>
          アカウントをお持ちでない方は{' '}
          <Link href="/signup" underline="none" sx={{ color: '#FE6B8B' }}>
            こちら
          </Link>
        </Typography>
      </AuthCard>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </AuthContainer>
  );
}

export default Login;
